import clsx from "clsx";
import { ragToBgClassMap } from "../../constants";

export type EvidenceRagChipProps = {
    red: number;
    amber: number;
};

const baseClasses = "text-center rounded-full text-xs py-1";

const EvidenceRagChip = ({ red, amber }: EvidenceRagChipProps) => {
    if (red !== 0) {
        return (
            <div
                className={clsx(
                    baseClasses,
                    ragToBgClassMap["red"],
                    "text-white"
                )}
            >
                {red} Missing
            </div>
        );
    }

    if (amber !== 0) {
        return (
            <div className={clsx(baseClasses, ragToBgClassMap["amber"])}>
                {amber} Expiring
            </div>
        );
    }

    return (
        <div className={clsx(baseClasses, ragToBgClassMap["green"])}>
            All OK
        </div>
    );
};

export default EvidenceRagChip;
